import { Navigate } from "react-router-dom";

import { isFeatureActive } from "utils/getFeature";

interface IFeatureProps {
  name: string;
  route?: boolean;
  children: JSX.Element;
}

const FeatureWrapper = ({ name, route, children }: IFeatureProps) => {
  if (isFeatureActive(name)) {
    return children;
  }

  return route ? <Navigate to="/notfound" /> : null;
};

export default FeatureWrapper;
